import { combineReducers } from "redux";
import search from './cms.reducer';

const reducer = combineReducers({
    search
});

export default reducer;